import { type AgentCreatorType } from '@atlaskit/rovo-agent-components/common/types';
import { isForgeAgentByCreatorType } from '@atlaskit/rovo-agent-components/common/utils/is-forge-agent';
import { type ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { getConversation } from './getConversation';

/**
 * Whether to rewrite HTML `<details>` / `<summary>` blocks into the Rovo-native
 * expand boundary before markdown rendering.
 *
 * Applies to third-party agents (Forge, traditional 3P, remote A2A) only. First-party agents'
 * output surface is controlled and should not need this rewrite.
 */
export const shouldPreprocessDetailsForConversation = (
	state: ChatStorePrivateState,
	conversationId: string,
): boolean => {
	const creatorType = getConversation(state, conversationId)?.agent?.creator_type as
		| AgentCreatorType
		| undefined;
	return !!creatorType && isForgeAgentByCreatorType(creatorType);
};
